import { ActionBarTab, Button } from "components"
import React, { useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"

import Templates from "./Templates/Templates"
import Surveys from "./Surveys/Surveys"

const Survey: React.FC<{}> = () => {
  const myParam = useLocation().search
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const page = searchParams.get("id")

  const [activeTab, setActiveTab] = useState(
    page ? (page === "template" ? 1 : 0) : 0
  )

  return (
    <>
      <div className="flex w-full justify-between items-center px-4 md:px-6 lg:px-10  bg-white">
        <div className="h-full flex items-center gap-6  border-y scrollbar-hide border-y-neutral40 overflow-x-auto">
          {[
            {
              title: "Surveys",
              url: "/dashboard/survey?id=survey",
            },
            {
              title: "Templates",
              url: "/dashboard/survey?id=template",
            },
          ].map((item, index) => (
            <ActionBarTab
              key={index}
              action={() => {
                setActiveTab(index)
                navigate(item?.url)
              }}
              active={index === activeTab}
              title={item.title}
            />
          ))}
        </div>
        <div>
          {activeTab === 0 ? (
            <Button
              color="primary"
              onClick={() => {
                navigate("/dashboard/survey/new")
              }}
            >
              Create Survey
            </Button>
          ) : (
            <Button
              color="primary"
              onClick={() => {
                navigate("/dashboard/survey/template")
              }}
            >
              Create Template
            </Button>
          )}
        </div>
      </div>

      {activeTab === 0 && <Surveys />}
      {activeTab === 1 && <Templates />}
    </>
  )
}
export default Survey
export const surveyTypes = [
  { survey_title: "General", survey_id: "1" },
  { survey_title: "Confirmation", survey_id: "2" },
  { survey_title: "Exit", survey_id: "3" },
]
